interface IPCIPaymentProviderProps {
    children?: React.ReactNode | React.ReactNode[];
}

export const PCIPaymentProvider = ({ children }: IPCIPaymentProviderProps) => (
    // todo

    <div>{children}</div>
);
